import React from 'react'

import {
  Box,
  Card,
  Divider,
  Grid,
  IconButton,
  Typography,
} from '@material-ui/core'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ArrowBackIos from '@material-ui/icons/ArrowBackIos'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import CheckIsMobile from '../../../../utils/isMobileHook'
import { trackEvent } from '../../../helpers/analytics'
import IconPicker from '../../apps/AppComponents/IconPicker/IconPicker'
import PageLink from '../components/PageLink'
import styles from '../settingsStyles'

function AppSupport() {
  const isMobile = CheckIsMobile()
  const classes = styles()
  const history = useHistory()
  const dispatch = useDispatch()

  const trackSupportClick = (actionContextValue) => {
    trackEvent(dispatch, {
      eventName: 'uxp_support_item_click',
      module: 'Settings',
      object: 'AppSupport',
      action: 'Click',
      actionContext: 'AppSupport',
      actionContextValue,
    })
  }

  const FAQurl =
    'https://ithelp.rutgers.edu/sp?id=kb_category&kb_id=6bd412391bfdc0108e4585d7cc4bcb9d&kb_category=6f30205b1bc680908e4585d7cc4bcb15'
  const vidurl = 'https://it.rutgers.edu/myrutgers/'

  return (
    <Box className={classes.centerPage}>
      <Grid
        alignItems="center"
        className={classes.container}
        container
        direction="column"
        wrap="nowrap"
      >
        <Grid
          alignItems="center"
          className={classes.sectionTitle}
          container
          direction="row"
          justifyContent="flex-start"
        >
          <IconButton
            aria-label="Back"
            className={classes.backButton}
            onClick={() => {
              trackEvent(dispatch, {
                eventName: 'uxp_settings_item_click',
                module: 'Settings',
                object: 'BackButton',
                action: 'Click',
                actionContext: 'AppSupport',
                actionContextValue: 'BackButton',
              })
              history.replace('/settings')
            }}
          >
            <ArrowBackIos fontSize="small" />
          </IconButton>
          <Typography variant="h1">
            <b>App Support</b>
          </Typography>
        </Grid>

        {isMobile ? (
          <Box sx={{ width: '100%' }}>
            <Grid
              alignItems="center"
              container
              direction="column"
              spacing={2}
              sx={{ width: '100%' }}
            >
              <Grid
                alignItems="center"
                container
                direction="row"
                justifyContent="flex-start"
              >
                <Card className={classes.supportHelpDeskCard}>
                  <section>
                    <List style={{ flex: 1 }}>
                      <ListItem className={classes.supportListItem}>
                        <Typography
                          style={{ fontWeight: 'bold', paddingTop: 5 }}
                          variant="h4"
                        >
                          Call Us
                        </Typography>
                      </ListItem>
                      <ListItem className={classes.supportListItem}>
                        <IconPicker
                          color="#c41f32"
                          iconName="fa-phone"
                          size="3x"
                        />
                      </ListItem>
                      <ListItem className={classes.supportListItem}>
                        <Typography className={classes.supportInfoItem}>
                          <b>Toll-Free Number: </b>
                        </Typography>
                      </ListItem>
                      <ListItem className={classes.supportListItem}>
                        <Typography className={classes.supportInfoItem}>
                          <a
                            href="tel:833-648-4357"
                            onClick={() =>
                              trackSupportClick('Toll-Free Number')
                            }
                          >
                            833-OIT-HELP
                          </a>
                        </Typography>
                      </ListItem>
                      <ListItem className={classes.supportListItem}>
                        <Typography className={classes.supportInfoItem}>
                          (833-648-4357)
                        </Typography>
                      </ListItem>
                    </List>
                  </section>
                </Card>
              </Grid>

              <Grid
                alignItems="center"
                container
                direction="row"
                justifyContent="flex-start"
              >
                <Card className={classes.supportHelpDeskCard}>
                  <section>
                    <List style={{ flex: 1 }}>
                      <ListItem className={classes.supportListItem}>
                        <Typography
                          style={{ fontWeight: 'bold', paddingTop: 5 }}
                          variant="h4"
                        >
                          Email Us
                        </Typography>
                      </ListItem>
                      <ListItem className={classes.supportListItem}>
                        <IconPicker
                          color="#c41f32"
                          iconName="fa-envelope-open"
                          size="3x"
                        />
                      </ListItem>
                      <ListItem className={classes.supportListItem}>
                        <Typography className={classes.supportInfoItem}>
                          <b>New Brunswick: </b>
                          <a
                            href="mailto:help@oit.rutgers.edu"
                            onClick={() =>
                              trackSupportClick('New Brunswick Email')
                            }
                          >
                            help@oit.rutgers.edu
                          </a>
                        </Typography>
                      </ListItem>
                      <ListItem className={classes.supportListItem}>
                        <Typography className={classes.supportInfoItem}>
                          <b>RBHS: </b>
                          <a
                            href="mailto:facstaffhelp@oit.rutgers.edu"
                            onClick={() => trackSupportClick('RBHS Email')}
                          >
                            facstaffhelp@oit.rutgers.edu
                          </a>
                        </Typography>
                      </ListItem>
                      <ListItem className={classes.supportListItem}>
                        <Typography className={classes.supportInfoItem}>
                          <b>Newark: </b>
                          <a
                            href="mailto:help@newark.rutgers.edu"
                            onClick={() => trackSupportClick('Newark Email')}
                          >
                            help@newark.rutgers.edu
                          </a>
                        </Typography>
                      </ListItem>
                      <ListItem className={classes.supportListItem}>
                        <Typography className={classes.supportInfoItem}>
                          <b>Camden: </b>
                          <a
                            href="mailto:help@camden.rutgers.edu"
                            onClick={() => trackSupportClick('Camden Email')}
                          >
                            help@camden.rutgers.edu
                          </a>
                        </Typography>
                      </ListItem>
                    </List>
                  </section>
                </Card>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <Box sx={{ width: '100%' }}>
            <Grid container spacing={4}>
              <Grid item xs={6}>
                <Card className={classes.supportHelpDeskCard}>
                  <section>
                    <List style={{ flex: 1 }}>
                      <ListItem className={classes.supportListItem}>
                        <Typography
                          style={{ fontWeight: 'bold', paddingTop: 5 }}
                          variant="h4"
                        >
                          Call Us
                        </Typography>
                      </ListItem>
                      <ListItem className={classes.supportListItem}>
                        <IconPicker
                          color="#c41f32"
                          iconName="fa-phone"
                          size="3x"
                        />
                      </ListItem>
                      <ListItem className={classes.supportListItem}>
                        <Typography className={classes.supportInfoItem}>
                          <b>Toll-Free Number: </b>
                        </Typography>
                      </ListItem>
                      <ListItem className={classes.supportListItem}>
                        <Typography className={classes.supportInfoItem}>
                          <a
                            href="tel:833-648-4357"
                            onClick={() =>
                              trackSupportClick('Toll-Free Number')
                            }
                          >
                            833-OIT-HELP
                          </a>
                        </Typography>
                      </ListItem>
                      <ListItem className={classes.supportListItem}>
                        <Typography className={classes.supportInfoItem}>
                          (833-648-4357)
                        </Typography>
                      </ListItem>
                    </List>
                  </section>
                </Card>
              </Grid>

              <Grid item xs={6}>
                <Card className={classes.supportHelpDeskCard}>
                  <section>
                    <List style={{ flex: 1 }}>
                      <ListItem className={classes.supportListItem}>
                        <Typography
                          style={{ fontWeight: 'bold', paddingTop: 5 }}
                          variant="h4"
                        >
                          Email Us
                        </Typography>
                      </ListItem>
                      <ListItem className={classes.supportListItem}>
                        <IconPicker
                          color="#c41f32"
                          iconName="fa-envelope-open"
                          size="3x"
                        />
                      </ListItem>
                      <ListItem className={classes.supportListItem}>
                        <Typography className={classes.supportInfoItem}>
                          <b>New Brunswick: </b>
                          <a
                            href="mailto:help@oit.rutgers.edu"
                            onClick={() =>
                              trackSupportClick('New Brunswick Email')
                            }
                          >
                            help@oit.rutgers.edu
                          </a>
                        </Typography>
                      </ListItem>
                      <ListItem className={classes.supportListItem}>
                        <Typography className={classes.supportInfoItem}>
                          <b>RBHS: </b>
                          <a
                            href="mailto:facstaffhelp@oit.rutgers.edu"
                            onClick={() => trackSupportClick('RBHS Email')}
                          >
                            facstaffhelp@oit.rutgers.edu
                          </a>
                        </Typography>
                      </ListItem>
                      <ListItem className={classes.supportListItem}>
                        <Typography className={classes.supportInfoItem}>
                          <b>Newark: </b>
                          <a
                            href="mailto:help@newark.rutgers.edu"
                            onClick={() => trackSupportClick('Newark Email')}
                          >
                            help@newark.rutgers.edu
                          </a>
                        </Typography>
                      </ListItem>
                      <ListItem className={classes.supportListItem}>
                        <Typography className={classes.supportInfoItem}>
                          <b>Camden: </b>
                          <a
                            href="mailto:help@camden.rutgers.edu"
                            onClick={() => trackSupportClick('Camden Email')}
                          >
                            help@camden.rutgers.edu
                          </a>
                        </Typography>
                      </ListItem>
                    </List>
                  </section>
                </Card>
              </Grid>
            </Grid>
          </Box>
        )}

        <Grid item className={classes.fullWidth}>
          <Card className={classes.linksCard}>
            <PageLink
              description="3000"
              eventName="uxp_support_item_click"
              link={() => window.open(FAQurl, '_blank')}
              section="AppSupport"
              title="FAQ"
            />
            <Divider className={classes.fullWidth} variant="middle" />
            <PageLink
              description="Useful info here."
              eventName="uxp_support_item_click"
              link={() => window.open(vidurl, '_blank')}
              section="AppSupport"
              title="Portal Tutorial Videos"
            />
          </Card>
        </Grid>
      </Grid>
    </Box>
  )
}

export default AppSupport
